import userService from "../../../services/user.service";


async function getVisitProfiles() {
  try {
    const payload = {
      pageNumber: -1,
      pageSize: 10,
      searchQuery: "",
    };

    const response = await userService.getvisitProfile(
      payload.pageNumber,
      payload.pageSize,
      payload.searchQuery
    );

    if (response.data && response.data.status) {
      return JSON.stringify(response.data.result);
    } else {
      return (
        JSON.stringify(response.data.message) ||
        "Failed to fetch visit profiles."
      );
    }
  } catch (error) {
    const errorMessage =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      "An unexpected error occurred.";
    console.error("Error fetching visit profiles:", errorMessage);
    return JSON.stringify(errorMessage);
  }
}

export default {
  getVisitProfiles,
  visitTools: [
    {
      type: "function",
      function: {
        name: "getVisitProfiles",
        description:
          "Fetch a list of visit profiles from database.",
        parameters: {
          type: "object",
          properties: {
            pageNumber: {
                type: "number",
                description:
                  "The page number for paginated results. Dont ask this just use default values. by default it is -1 for fetching all roles",
              },
              pageSize: {
                type: "number",
                description:
                  "The number of items per page. by default it is 0 for fetching all roles",
              },
              searchQuery: {
                type: "string",
                description:
                  "Search query to filter cities. by default it is empty string for fetching all roles",
              },
        }
        },
      },
    },
  ],
};
